import React from 'react'
import Card from '../../components/Card'
import './style.scss'
import { objCards } from '../../constants/SelectCardsActive' 


export default function SectionCardsActive() {
	return (
		<section className="container-section-cards">
			<div className="container-text">
				<p>Recebeu, ativou, usou.</p>
				<span>Fácil assim.</span>
			</div>
			<div className="container-cards">
				{
					objCards.map(card => (
						<Card img={card.img} title={card.title} description={card.description} />
					))
				}
			</div>
		</section>
	)
}